// Dependencias
import JSPDF from 'jspdf';
import Canvg from 'canvg';
import Moment from 'moment-timezone';
import qrcode from 'qrcode-generator';
import axios from 'axios';
import generate from '../generateRef';
import currencyFormater from '../currencyFormater';
// Imagenes (file)
import imgAcudeBancos from './acudeBancos';
import imgBannerFondo from './bannerFondo';
import imgBannerPago from './bannerPago';
import imgColors from './colors';
import imgFooterImage from './footerImage';
import imgGraciasPorApoyo from './graciasPorApoyo';

Moment.locale('es');

const currDate = new Moment().tz('America/Mexico_City');
const currentDate = currDate.format('DD/MM/YYYY');
const currentYear = currDate.format('YYYY');
const expMonth = 1;
const expDay = 29;
const expDate = new Moment([
  currentYear,
  expMonth,
  expDay,
]);

const expDateStr = `${expDate.format('DD')} de ${expDate.format('MMMM')} ${expDate.format('YYYY')}`;
const prevYear = parseInt(currDate.format('YYYY'), 10) - 1;
const JsBarcode = require('jsbarcode');

/**
 * Genera instancia JSPDF para el recibo de estado de cuenta con QR.
 * @param {Object} predio y cargos
 * @returns {Object}
 */

export default async ({
  predio,
  totals,
  houseInsurance,
  dateForLink,

}) => {
  try {
    const {
      debtsTotalBase,
      actTotal,
      surchargeTotal,
      notificationTotal,
      finesTotal,
      discountEarlyPay,
      specialDiscountTotal,
      debtsTotalRounded,
      debtsTotalExtra,
      houseInsuranceTotal,
      healthServicesTotal,
      total,
      firstPeriod,
      lastPeriod,
    } = totals;

    let text = '';
    let x = 30;
    let y = 10;
    let cx;
    const doc = new JSPDF({ unit: 'mm', format: 'letter' });

    // Cabecera
    doc.addImage(imgColors, 'JPEG', x, y, 150, 2, '', 'FAST');
    y += 4;
    doc.addImage(imgBannerPago, 'JPEG', x, y, 150, 12, '', 'FAST');

    // Datos generales del predio
    doc.setFillColor(202, 177, 229);
    doc.setDrawColor(202, 177, 229);
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(12);
    doc.setFontStyle('bold');
    y += 13;
    doc.roundedRect(x, y, 75, 8, 4, 4, 'FD');
    x += 3;
    y += 5.5;
    doc.text('DATOS GENERALES DEL PREDIO', x, y, {
      align: 'left',
      maxWidth: 100,
    });
    doc.setFontSize(10);
    doc.setDrawColor(0, 0, 0);
    doc.setFillColor(0, 0, 0);
    doc.setTextColor(0, 0, 0);
    x -= 4;
    y += 7.5;
    doc.text(`Nombre: ${predio.nombrecompletopropietario}`, x, y, {
      maxWidth: 70,
    });
    y += 12;
    doc.text(`Ubicación: ${predio.ubicacion}`, x, y, { maxWidth: 70 });
    y += 16;
    doc.text(
      `Valor terreno: ${currencyFormater(predio.valor_del_terreno)}`,
      x,
      y,
      { maxWidth: 70 },
    );
    y += 4;
    doc.text(
      `Valor construcción: ${currencyFormater(
        predio.valor_de_la_construccion,
      )}`,
      x,
      y,
      { maxWidth: 70 },
    );
    y += 4;
    doc.text(
      `Valor fiscal: ${currencyFormater(predio.valor_de_fiscal)}`,
      x,
      y,
      { maxWidth: 70 },
    );
    y += 4;
    doc.text(`Dom. a notificar: ${predio.domicilio_notificacion}`, x, y, {
      maxWidth: 70,
    });
    x = 106;
    y = 40;
    if (predio.clave_catastral.length > 1) {
      doc.text(`Clave catastral: ${predio.clave_catastral}`, x, y, {
        maxWidth: 70,
      });
    } else {
      doc.text(`CURT: ${predio.curt}`, x, y, { maxWidth: 70 });
    }
    y += 12;
    if (predio.cuentadepredial.length > 1) {
      doc.text(`Cuenta: ${predio.cuentadepredial}`, x, y, { maxWidth: 70 });
    }
    y += 8;
    doc.text(`Superficie terreno: ${predio.superficie_terreno}`, x, y, {
      maxWidth: 70,
    });
    y += 4;
    doc.text(`Superficie construida: ${predio.superficie_construida}`, x, y, {
      maxWidth: 70,
    });
    y += 4;
    doc.text(`Estatus del predio: ${predio.estatus_del_predio}`, x, y, {
      maxWidth: 70,
    });
    x = 105;
    y = 75;
    doc.addImage(imgGraciasPorApoyo, 'JPEG', x, y, 75, 19, '', 'FAST');
    y += 27;
    doc.setFontSize(8);
    text = 'EL PRESENTE ESTADO DE CUENTA ES VÁLIDO ÚNICAMENTE EL DÍA DE SU EXPEDICIÓN, Y ES '
    + 'EXCLUSIVAMENTE DE CARÁCTER INFORMATIVO; POR LO QUE NO SURTE EFECTOS JURÍDICOS A LOS CONTRIBUYENTES '
    + 'POR NO TRATARSE DE UNA RESOLUCIÓN ADMINISTRATIVA Y/O REQUERIMIENTO DE PAGO, DE CONFORMIDAD CON '
    + 'EL CÓDIGO FISCAL DE LA FEDERACIÓN Y EL ARTÍCULO 100 DEL CÓDIGO FISCAL DEL ESTADO DE JALISCO, VIGENTES.';

    doc.text(text, 30, y, { align: 'justify', maxWidth: 150 });
    y += 18;

    text = 'ESTE DOCUMENTO NO ES VÁLIDO COMO COMPROBANTE DE PAGO, NI EXIME AL CONTRIBUYENTE DE '
    + 'ADEUDOS POSTERIORES A LA IMPRESIÓN DEL MISMO.';
    doc.text(text, 30, y, { align: 'justify', maxWidth: 150 });
    y += 9;

    text = `PARA PAGO EN SUCURSALES BANCARIAS, KIOSCOS, RECAUDADORAS, TIENDAS DE CONVENIENCIA
      VIGENTE SOLO PARA EL DÍA DE HOY ${currentDate}. UN DÍA DE RETRASO EN SU PAGO PODRÍA GENERAR
      OTROS CARGOS A LA FECHA DE IMPRESIÓN.`;
    doc.text(text, 30, y, { align: 'justify', maxWidth: 150 });
    doc.setFontStyle('normal');
    text = 'DESCUENTO ESPECIAL (DESP.): Descuento especial por concepto de tercera edad, pensionado, '
      + `jubilado y otros, se calcula de manera automática a quienes renovaron su descuento en ${prevYear}.\n`
      + 'DESCUENTO POR PRONTO PAGO(PAG.): Descuento que se otorga a todos los contribuyentes en el'
      + ` impuesto predial ${currentYear} respectivo al 10% y vigente al ${expDateStr}. El Impuesto `
      + `Predial correspondiente al ejercicio fiscal ${currentYear}, se calcula de acuerdo a lo que resulte de`
      + ' aplicar bimestralmente a la base fiscal, las cuotas y tasas establecidas por el articulo 45, '
      + 'fracción I, de la Ley de Ingresos del Municipio de Zapopan, Jalisco, para el Ejercicio Fiscal'
      + ` del año ${currentYear}.`;
    y += 12;
    x = 30;
    doc.text(text, 30, y, { maxWidth: 150, align: 'justify' });

    doc.setFillColor(146, 104, 203);
    doc.setDrawColor(146, 104, 203);
    doc.setTextColor(255, 255, 255);
    doc.setFontStyle('bold');
    y -= 47.5;
    doc.roundedRect(x, y, 150, 4, 2, 2, 'FD');
    doc.setFontSize(6);

    y += 2.7;

    doc.text(
      'Información Proactiva Impuesto Predial: www.zapopan.gob.mx/info-predial',
      35,
      y,
      { align: 'left', maxWidth: 100 },
    );
    x = 175;
    doc.text(
      'Correo: informacionpredial@zapopan.gob.mx',
      x,
      y,
      {
        align: 'right',
        maxWidth: 50,
      },
    );
    doc.setFontSize(14);
    doc.setFillColor(202, 177, 229);
    doc.setDrawColor(202, 177, 229);
    x = 30;
    y += 75.5;
    doc.roundedRect(x, y, 150, 5, 2.5, 2.5, 'FD');
    x = 55;
    y -= 10;
    doc.roundedRect(x, y, 100, 8, 4, 4, 'FD');
    x += 50;
    y += 5.5;
    doc.text('ADEUDO AL DÍA DE HOY', x, y, {
      align: 'center',
      maxWidth: 100,
    });
    doc.setFontSize(12);
    x = 40;
    y += 8.5;
    doc.text('CONCEPTO', x, y);
    x += 100;
    doc.text('IMPORTE', x, y);
    doc.setDrawColor(0, 0, 0);
    doc.setFillColor(0, 0, 0);
    doc.setTextColor(0, 0, 0);

    // Conceptos
    doc.setFontSize(9);
    doc.setFontStyle('bold');
    x = 40;
    y += 6;
    doc.text(
      `El adeudo cubre del periodo ${firstPeriod.year} . ${firstPeriod.num} al periodo ${lastPeriod.year}. ${lastPeriod.num}`,
      x,
      y,
      { maxWidth: 150 },
    );
    y += 2;
    const conceptos = [
      'Impuesto causado',
      'Actualización',
      'Recargo',
      'Gastos de notificación',
      'Multas',
      'Descuento por pronto pago 10% y/o 3ra edad',
      'Descuento multas y recargos',
      'Redondeo',
      'IMPORTE A PAGAR',
      'Aportación OPD Servicios de Salud del Municipio de Zapopan',
    ];
    if (houseInsurance) {
      conceptos.push('Seguro exclusivo casa habitación');
    }
    conceptos.push('TOTAL A PAGAR');
    conceptos.forEach((concepto) => {
      y += 5;
      doc.text(concepto, x, y, { maxWidth: 120 });
    });

    // Importes
    const importes = [
      debtsTotalBase,
      actTotal,
      surchargeTotal,
      notificationTotal,
      finesTotal,
      discountEarlyPay,
      specialDiscountTotal,
      debtsTotalExtra,
      debtsTotalRounded,
      healthServicesTotal,
    ];
    if (houseInsurance) {
      importes.push(houseInsuranceTotal);
    }
    importes.push(total);
    y = 183.5;
    x = 160;
    doc.setFontStyle('normal');
    importes.forEach((importe) => {
      y += 5;
      doc.text(currencyFormater(importe), x, y, {
        maxWidth: 25,
        align: 'right',
      });
    });
    x = 35;
    y += 10;

    // Divider
    doc.setFillColor(199, 174, 211);
    doc.setDrawColor(199, 174, 211);
    doc.rect(x, y, 140, 1, 'F');
    /* x -= 5;
    y += 5;
    doc.addImage(imgFooterImage, 'JPEG', x, y, 150, 25, '', 'FAST'); */
    x -= -1;
    y += 3;
    doc.addImage(imgFooterImage, 'JPEG', x, y, 137, 22, '', 'FAST');
    doc.addPage();

    const ref = predio.cuentadepredial.length === 10
      ? predio.cuentadepredial : predio.pk.toString().padStart(10, '0');
    const qrs = [];
    const barcodes = [];
    const codes = [];
    const uris = [];
    const amounts = [
      total,
      total - healthServicesTotal,
      total - houseInsuranceTotal,
      total - healthServicesTotal - houseInsuranceTotal,
    ];
    for (let idx = 0; idx < 4; idx++) {
      // Creando referencia
      const { LINEA_BANCOS, LINEA_OXXO } = generate(
        currentDate,
        amounts[idx],
        ref,
      );

      if (LINEA_OXXO) {
        // Creando codigo de barras
        const xmlSerializer = new XMLSerializer();
        const docum = document.implementation.createDocument(
          'http://www.w3.org/1999/xhtml',
          'html',
          null,
        );
        const svgNode = docum.createElementNS(
          'http://www.w3.org/2000/svg',
          'svg',
        );

        JsBarcode(svgNode, LINEA_OXXO, {
          xmlDocument: docum,
          height: 50,
        });
        const svgText = xmlSerializer.serializeToString(svgNode);
        let svg = svgText;
        svg = svg.replace(/\r?\n|\r/g, '').trim();
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        // eslint-disable-next-line no-await-in-loop
        const v = await Canvg.from(ctx, svg);
        v.start();
        // eslint-disable-next-line no-await-in-loop
        const imgData = await canvas.toDataURL('image/png');
        barcodes.push(imgData);
      } else {
        barcodes.push(false);
      }

      // Creando QR
      if (LINEA_BANCOS) {
        const qr = qrcode(0, 'L');
        const baseURL = 'http://pagos.zapopan.gob.mx/PortalCiudadano/Recaudacion/RecaudoPredialQR.aspx?';
        // const baseURL = 'https://pruebasigob.zapopan.gob.mx/PortalCiudadanoPagoPruebas/Recaudacion/RecaudoPredialQR.aspx?';
        const URI = `${baseURL}OidPredio=${predio.pk}&Importe=${amounts[idx].toFixed(2)}&FechaPago=${dateForLink}`;
        uris.push(URI);
        qr.addData(URI);
        qr.make();
        const data = qr.createDataURL();
        qrs.push(data);
        codes.push(LINEA_BANCOS);
      } else {
        qrs.push(false);
        codes.push(false);
      }
    }

    const blank = '    ';
    doc.setFontSize(12);
    doc.setFontStyle('bold');
    x = 105;
    y = 15;
    doc.text('Escanea o da clic en el código QR de tu preferencia', x, y, { align: 'center' });
    if (houseInsurance) {
      x = 10 + (190 / 4);
      y += 8;
      doc.text('Con seguro con donativo', x, y, { maxWidth: 75, align: 'center' });
      x = 10 + (190 / 4) * 3;
      doc.text('Con seguro sin donativo', x, y, { maxWidth: 75, align: 'center' });
      doc.setFontStyle('normal');
      doc.setFontSize(10);

      const marginBottomTitle = 5;
      const marginBottomQr = 30;
      const marginBottomBarCode = 20;
      const marginBottomAdeudo = 10;
      // const marginBottomCode = 10;
      // Validación QR
      const exceedMsg = 'Las cantidades a pagar exceden los límites establecidos';
      if (qrs[0]) {
        x = 10 + (190 / 4) - 11;
        y += marginBottomTitle;
        doc.addImage(qrs[0], 'JPEG', x, y, 22, 27.3, '', 'FAST');
        doc.setFontSize(55);
        doc.textWithLink(blank, x, y + 20, { url: uris[0] });
        doc.setFontSize(10);
        y += marginBottomQr;
      } else {
        doc.setFontStyle('bold');
        x = 10 + (190 / 4);
        y += marginBottomTitle + 15;
        doc.text(
          exceedMsg,
          x,
          y,
          { maxWidth: 70, align: 'center' },
        );
        doc.setFontStyle('normal');
        y += marginBottomQr - 10;
      }

      // Validación código de barras
      x = 10 + (190 / 4);
      if (barcodes[0]) {
        doc.addImage(barcodes[0], 'JPEG', x - 35, y, 70, 15);
      } else {
        doc.setFontStyle('bold');
        doc.text(
          exceedMsg,
          x,
          y,
          { maxWidth: 60, align: 'center' },
        );
        doc.setFontStyle('normal');
      }
      y += marginBottomBarCode;
      doc.setFontSize(6);
      doc.text(`ADEUDO A LA FECHA  ${dateForLink}`, x - 15, y, { maxWidth: 25, align: 'center' });
      doc.setFontSize(8);
      doc.text(`${currencyFormater(amounts[0])}`, x + 15, y + 2.5, {
        maxWidth: 30,
        align: 'center',
      });
      if (codes[0]) {
        y += marginBottomAdeudo;
        doc.text(`${codes[0]}`, x, y, { maxWidth: 75, align: 'center' });
      }
      doc.setFontSize(8);
      doc.setFontStyle('bold');
      doc.text('ESTE MONTO SOLO VALIDO EN ESTA FECHA', x - 39, y + 5, { maxWidth: 175, align: 'left' });
      cx = 10 + (190 / 4);
      y += 5;
      doc.setFontStyle('bold');
      doc.text('PAGO VIA SPEI DESDE CUALQUIER BANCO:', cx, y + 5, { align: 'center' });
      doc.setFontSize(8);
      doc.setTextColor(0, 0, 0);
      doc.text('REFERENCIA (CONCEPTO):', cx - 16, y + 10, { align: 'center' });
      doc.text('CLABE INTERBANCARIA:', cx - 17, y + 15, { align: 'center' });
      doc.text(codes[0], cx + 3, y + 10);
      doc.text('012914002004511392', cx + 2, y + 15);
      doc.setFontStyle('normal');
      y += 15; doc.setFontSize(10);
      // Dibujando dividers
      doc.setDrawColor(161, 120, 252);
      doc.setLineWidth(0.3);
      doc.line(105, 33, 105, 80);

      y = 23;
      if (qrs[1]) {
        x = 10 + (190 / 4) * 3 - 11;
        y += marginBottomTitle;
        doc.addImage(qrs[1], 'JPEG', x, y, 22, 27.3, '', 'FAST');
        doc.setFontSize(55);
        doc.textWithLink(blank, x, y + 20, { url: uris[1] });
        doc.setFontSize(10);
        y += marginBottomQr;
      } else {
        doc.setFontStyle('bold');
        x = 10 + (190 / 4) * 3;
        y += 20;
        doc.text(
          exceedMsg,
          x,
          y,
          { maxWidth: 70, align: 'center' },
        );
        doc.setFontStyle('normal');
        y += marginBottomQr - 10;
      }

      // Validación código de barras
      x = 10 + (190 / 4) * 3;
      if (barcodes[1]) {
        doc.addImage(barcodes[1], 'JPEG', x - 35, y, 70, 15);
      } else {
        doc.setFontStyle('bold');
        doc.text(
          exceedMsg,
          x,
          y,
          { maxWidth: 60, align: 'center' },
        );
        doc.setFontStyle('normal');
      }
      y += marginBottomBarCode;
      doc.setFontSize(6);
      doc.text(`ADEUDO A LA FECHA  ${dateForLink}`, x - 15, y - 4, { maxWidth: 25, align: 'center' });
      doc.setFontSize(8);
      doc.text(`${currencyFormater(amounts[1])}`, x + 15, y + 2.5, {
        maxWidth: 30,
        align: 'center',
      });
      if (codes[1]) {
        y += marginBottomAdeudo;
        doc.text(`${codes[1]}`, x, y, { maxWidth: 75, align: 'center' });
      }
      doc.setFontSize(8);
      doc.setFontStyle('bold');
      doc.text('ESTE MONTO SOLO VALIDO EN ESTA FECHA', x - 39, y + 5, { maxWidth: 175, align: 'left' });
      cx = 10 + (190 / 4) * 3;
      y += 5;
      doc.setFontStyle('bold');
      doc.text('PAGO VIA SPEI DESDE CUALQUIER BANCO:', cx, y + 5, { align: 'center' });
      doc.setFontSize(8);
      doc.setTextColor(0, 0, 0);
      doc.text('REFERENCIA (CONCEPTO):', cx - 16, y + 10, { align: 'center' });
      doc.text('CLABE INTERBANCARIA:', cx - 17, y + 15, { align: 'center' });
      doc.text(codes[1], cx + 3, y + 10);
      doc.text('012914002004511392', cx + 2, y + 15);
      doc.setFontStyle('normal');
      y += 15; doc.setFontSize(10);

      y += 10;
      const backToTop = y;
      doc.setFontSize(12);
      doc.setFontStyle('bold');
      x = 10 + (190 / 4);
      doc.text('Sin seguro con donativo', x, y, { maxWidth: 75, align: 'center' });
      x = 10 + (190 / 4) * 3;
      doc.text('Sin seguro sin donativo', x, y, { maxWidth: 75, align: 'center' });
      doc.setFontStyle('normal');
      doc.setFontSize(10);
      if (qrs[2]) {
        x = 10 + (190 / 4) - 11;
        y += marginBottomTitle;
        doc.addImage(qrs[2], 'JPEG', x, y, 22, 27.3, '', 'FAST');
        doc.setFontSize(55);
        doc.textWithLink(blank, x, y + 20, { url: uris[2] });
        doc.setFontSize(10);
        y += marginBottomQr;
      } else {
        doc.setFontStyle('bold');
        x = 10 + (190 / 4);
        y += 20;
        doc.text(
          exceedMsg,
          x,
          y,
          { maxWidth: 70, align: 'center' },
        );
        doc.setFontStyle('normal');
        y += marginBottomQr - 10;
      }

      // Validación código de barras
      x = 10 + (190 / 4);
      if (barcodes[2]) {
        doc.addImage(barcodes[2], 'JPEG', x - 35, y, 70, 15);
      } else {
        doc.setFontStyle('bold');
        doc.text(
          exceedMsg,
          x,
          y,
          { maxWidth: 60, align: 'center' },
        );
        doc.setFontStyle('normal');
      }
      y += marginBottomBarCode;
      doc.setFontSize(6);
      doc.text(`ADEUDO A LA FECHA  ${dateForLink}`, x - 15, y, { maxWidth: 25, align: 'center' });
      doc.setFontSize(8);
      doc.text(`${currencyFormater(amounts[2])}`, x + 15, y + 2.5, {
        maxWidth: 30,
        align: 'center',
      });
      if (codes[2]) {
        y += marginBottomAdeudo;
        doc.text(`${codes[2]}`, x, y, { maxWidth: 75, align: 'center' });
      }
      doc.setFontSize(8);
      doc.setFontStyle('bold');
      doc.text('ESTE MONTO SOLO VALIDO EN ESTA FECHA', x - 39, y + 5, { maxWidth: 175, align: 'left' });
      cx = 10 + (190 / 4);
      y += 5;
      doc.setFontStyle('bold');
      doc.text('PAGO VIA SPEI DESDE CUALQUIER BANCO:', cx, y + 5, { align: 'center' });
      doc.setFontSize(8);
      doc.setTextColor(0, 0, 0);
      doc.text('REFERENCIA (CONCEPTO):', cx - 16, y + 10, { align: 'center' });
      doc.text('CLABE INTERBANCARIA:', cx - 17, y + 15, { align: 'center' });
      doc.text(codes[2], cx + 3, y + 10);
      doc.text('012914002004511392', cx + 2, y + 15);
      doc.setFontStyle('normal');
      doc.setFontSize(10);
      y = backToTop;
      doc.line(105, y + 10, 105, y + 57);

      if (qrs[3]) {
        x = 10 + (190 / 4) * 3 - 11;
        y += marginBottomTitle;
        doc.addImage(qrs[3], 'JPEG', x, y, 22, 27.3, '', 'FAST');
        doc.setFontSize(55);
        doc.textWithLink(blank, x, y + 20, { url: uris[3] });
        doc.setFontSize(10);
        y += marginBottomQr;
      } else {
        doc.setFontStyle('bold');
        x = 10 + (190 / 4) * 3;
        y += 20;
        doc.text(
          exceedMsg,
          x,
          y,
          { maxWidth: 70, align: 'center' },
        );
        doc.setFontStyle('normal');
        y += marginBottomQr - 10;
      }

      // Validación código de barras
      x = 10 + (190 / 4) * 3;
      if (barcodes[3]) {
        doc.addImage(barcodes[3], 'JPEG', x - 35, y, 70, 15);
      } else {
        doc.setFontStyle('bold');
        doc.text(
          exceedMsg,
          x,
          y,
          { maxWidth: 60, align: 'center' },
        );
        doc.setFontStyle('normal');
      }
      y += marginBottomBarCode;
      doc.setFontSize(6);
      doc.text(`ADEUDO A LA FECHA  ${dateForLink}`, x - 15, y, { maxWidth: 25, align: 'center' });
      doc.setFontSize(8);
      doc.text(`${currencyFormater(amounts[3])}`, x + 15, y + 2.5, {
        maxWidth: 30,
        align: 'center',
      });
      if (codes[3]) {
        y += marginBottomAdeudo;
        doc.text(`${codes[3]}`, x, y, { maxWidth: 75, align: 'center' });
      }
      doc.setFontSize(8);
      doc.setFontStyle('bold');
      doc.text('ESTE MONTO SOLO VALIDO EN ESTA FECHA', x - 39, y + 5, { maxWidth: 175, align: 'left' });
      cx = 10 + (190 / 4) * 3;
      y += 5;
      doc.setFontStyle('bold');
      doc.text('PAGO VIA SPEI DESDE CUALQUIER BANCO:', cx, y + 5, { align: 'center' });
      doc.setFontSize(8);
      doc.setTextColor(0, 0, 0);
      doc.text('REFERENCIA (CONCEPTO):', cx - 16, y + 10, { align: 'center' });
      doc.text('CLABE INTERBANCARIA:', cx - 17, y + 15, { align: 'center' });
      doc.text(codes[3], cx + 3, y + 10);
      doc.text('012914002004511392', cx + 2, y + 15);
      doc.setFontStyle('normal');
      y += 15; doc.setFontSize(10);
    } else {
      doc.text('Escanea o da clic en el código QR de tu preferencia', x, y, { align: 'center' });
      x = 10 + (190 / 4);
      y += 8;
      doc.text('Con donativo', x, y, { maxWidth: 75, align: 'center' });
      x = 10 + (190 / 4) * 3;
      doc.text('Sin donativo', x, y, { maxWidth: 75, align: 'center' });
      doc.setFontStyle('normal');
      doc.setFontSize(10);

      const marginBottomTitle = 5;
      const marginBottomQr = 30;
      const marginBottomBarCode = 20;
      const marginBottomAdeudo = 10;
      // const marginBottomCode = 10;
      // Validación QR
      const exceedMsg = 'Las cantidades a pagar exceden los límites establecidos';
      if (qrs[2]) {
        x = 10 + (190 / 4) - 11;
        y += marginBottomTitle;
        doc.addImage(qrs[2], 'JPEG', x, y, 22, 27.3, '', 'FAST');
        doc.setFontSize(55);
        doc.textWithLink(blank, x, y + 20, { url: uris[2] });
        doc.setFontSize(10);
        y += marginBottomQr;
      } else {
        doc.setFontStyle('bold');
        x = 10 + (190 / 4);
        y += marginBottomTitle + 15;
        doc.text(
          exceedMsg,
          x,
          y,
          { maxWidth: 70, align: 'center' },
        );
        doc.setFontStyle('normal');
        y += marginBottomQr - 10;
      }

      // Validación código de barras
      x = 10 + (190 / 4);
      if (barcodes[2]) {
        doc.addImage(barcodes[2], 'JPEG', x - 35, y, 70, 15);
      } else {
        doc.setFontStyle('bold');
        doc.text(
          exceedMsg,
          x,
          y,
          { maxWidth: 60, align: 'center' },
        );
        doc.setFontStyle('normal');
      }
      y += marginBottomBarCode;

      doc.setFontSize(6);
      doc.text(`ADEUDO A LA FECHA  ${dateForLink}`, x - 15, y - 4, { maxWidth: 25, align: 'center' });
      doc.setFontSize(8);
      doc.text(`${currencyFormater(amounts[2])}`, x + 15, y + 2.5, {
        maxWidth: 30,
        align: 'center',
      });
      if (codes[2]) {
        y += marginBottomAdeudo;
        doc.text(`${codes[2]}`, x, y, { maxWidth: 75, align: 'center' });
      }
      doc.setFontSize(8);
      doc.setFontStyle('bold');
      doc.text('ESTE MONTO SOLO VALIDO EN ESTA FECHA', x - 39, y + 5, { maxWidth: 175, align: 'left' });
      doc.setFontStyle('normal');
      cx = 10 + (190 / 4);
      y += 5;
      doc.setFontSize(10);
      doc.setFontStyle('bold');
      doc.text('PAGO VIA SPEI DESDE CUALQUIER BANCO:', cx, y + 5, { align: 'center' });
      doc.setFontSize(8);
      doc.setTextColor(0, 0, 0);
      doc.text('REFERENCIA (CONCEPTO):', cx - 16, y + 10, { align: 'center' });
      doc.text('CLABE INTERBANCARIA:', cx - 17, y + 15, { align: 'center' });
      doc.text(codes[2], cx + 3, y + 10);
      doc.text('012914002004511392', cx + 2, y + 15);
      doc.setFontStyle('normal');
      doc.setFontSize(10);
      // Dibujando dividers
      doc.setDrawColor(161, 120, 252);
      doc.setLineWidth(0.3);
      doc.line(105, 33, 105, 80);

      y = 23;
      if (qrs[3]) {
        x = 10 + (190 / 4) * 3 - 11;
        y += marginBottomTitle;
        doc.addImage(qrs[3], 'JPEG', x, y, 22, 27.3, '', 'FAST');
        doc.setFontSize(55);
        doc.textWithLink(blank, x, y + 20, { url: uris[3] });
        doc.setFontSize(10);
        y += marginBottomQr;
      } else {
        doc.setFontStyle('bold');
        x = 10 + (190 / 4) * 3;
        y += 20;
        doc.text(
          exceedMsg,
          x,
          y,
          { maxWidth: 70, align: 'center' },
        );
        doc.setFontStyle('normal');
        y += marginBottomQr - 10;
      }

      // Validación código de barras
      x = 10 + (190 / 4) * 3;
      if (barcodes[3]) {
        doc.addImage(barcodes[3], 'JPEG', x - 35, y, 70, 15);
      } else {
        doc.setFontStyle('bold');
        doc.text(
          exceedMsg,
          x,
          y,
          { maxWidth: 60, align: 'center' },
        );
        doc.setFontStyle('normal');
      }
      y += marginBottomBarCode;
      doc.setFontSize(6);
      doc.text(`ADEUDO A LA FECHA  ${dateForLink}`, x - 15, y - 4, { maxWidth: 25, align: 'center' });
      doc.setFontSize(8);
      doc.text(`${currencyFormater(amounts[3])}`, x + 15, y + 2.5, {
        maxWidth: 30,
        align: 'center',
      });
      if (codes[3]) {
        y += marginBottomAdeudo;
        doc.text(`${codes[3]}`, x, y, { maxWidth: 75, align: 'center' });
      }
      doc.setFontSize(8);
      doc.setFontStyle('bold');
      doc.text('ESTE MONTO SOLO VALIDO EN ESTA FECHA', x - 39, y + 5, { maxWidth: 175, align: 'left' });
      doc.setFontSize(10);
      cx = 10 + (190 / 4) * 3;
      y += 5;
      doc.setFontStyle('bold');
      doc.text('PAGO VIA SPEI DESDE CUALQUIER BANCO:', cx, y + 5, { align: 'center' });
      doc.setFontSize(8);
      doc.setTextColor(0, 0, 0);
      doc.text('REFERENCIA (CONCEPTO):', cx - 16, y + 10, { align: 'center' });
      doc.text('CLABE INTERBANCARIA:', cx - 17, y + 15, { align: 'center' });
      doc.text(codes[3], cx + 3, y + 10);
      doc.text('012914002004511392', cx + 2, y + 15);
      doc.setFontStyle('normal');
      y += 15; doc.setFontSize(10);
    }
    y += 10;

    doc.setFontSize(8);
    doc.text('BBVA: 451139 | Santander: 618 | Scotiabank: 1519 | HSBC: 1415 | Banorte: 8247 | Banamex: 4905 | Banco del Bajio: 668', 30, y, {});

    /* doc.text('BBVA Bancomer: 451139', 48.5, y, {
      maxWidth: 37.5,
      align: 'center',
    });
    doc.text('Santander: 618', 86.5, y, { maxWidth: 37.5, align: 'center' });
    doc.text('Scotiabank: 1519', 124, y, { maxWidth: 37.5, align: 'center' });
    doc.text('HSBC: 1415', 161.5, y, { maxWidth: 37.5, align: 'center' });
    y += 10;
    doc.text('Banorte: 8247', 55, y, { maxWidth: 50, align: 'center' });
    doc.text('Banamex: 1104', 105, y, { maxWidth: 50, align: 'center' });
    doc.text('Banco del Bajio: 668', 155, y, {
      maxWidth: 50,
      align: 'center',
    });
    //y += 8;
    //doc.addImage(imgAcudeBancos, 'JPEG', 30, y, 120, 10, '', 'FAST');
    y += 15;
    doc.addImage(imgBannerFondo, 'JPEG', 30, y, 150, 35, '', 'FAST');
    console.log('codes ');
    console.log(codes);
    console.log('predio en recibo ');
    console.log(predio);
    console.log('cargos en recibo '+predio.cargos);
    /*
      const resGuardarRef = await axios.post(
      "https://indicadores.zapopan.gob.mx:8080/WSCajaWeb/api/guardaReferenciaWeb",
      {
        padron_id: predio.pk.toString(),
        total: total,
        redondeo: debtsTotalExtra,
        idConsulta: predio.idConsulta,
        anio: currentYear,
        bim: 6,
        canalDePago: 0,
        referencia: codes[0],
        referenciaopd: codes[1],
        referenciaseguro: codes[2],
        referenciaopdseguro: codes[3],
        cargos: predio.cargos,
      }

    );
    */
    return doc;
  } catch (err) {
    console.error(err);
    return err;
  }
};

// Cambios del nuevo recibo JEO
// export default async ({
async function reciboJEO({
  predio,
  totals,
  houseInsurance,
  dateForLink,

}) /*= > */ {
  try {
    const {
      debtsTotalBase,
      actTotal,
      surchargeTotal,
      notificationTotal,
      finesTotal,
      discountEarlyPay,
      specialDiscountTotal,
      debtsTotalRounded,
      debtsTotalExtra,
      houseInsuranceTotal,
      healthServicesTotal,
      total,
      firstPeriod,
      lastPeriod,
    } = totals;

    let text = '';
    let x = 30;
    let y = 10;
    let cx;
    const doc = new JSPDF({ unit: 'mm', format: 'letter' });

    // Cabecera
    // doc.addImage(imgColors, 'JPEG', x, y, 150, 2, '', 'FAST');
    doc.addImage(imgBannerPago, 'JPEG', 25, 2, 170, 18, '', 'FAST');

    // Datos generales del predio
    doc.setFillColor(27, 1, 116);
    doc.setDrawColor(27, 1, 116);
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(10);
    // doc.setFontStyle('bold');
    y += 13;
    doc.roundedRect(25, 24, 165, 4, 0, 0, 'FD');
    doc.roundedRect(25, 20, 165, 8, 4, 4, 'FD');
    x += 3;
    y += 5.5;
    doc.setFontStyle('bold');
    doc.text('DATOS GENERALES DEL PREDIO', 107.9, 25.5, { align: 'center' });
    doc.setFontStyle('normal');

    doc.setFontSize(10);
    doc.setDrawColor(0, 0, 0);
    // doc.setFillColor(0, 0, 0);
    doc.setTextColor(0, 0, 0);
    doc.roundedRect(25, 20, 165, 54, 4, 4, 'S');

    x -= 4;
    y += 5.5;
    doc.text(`Nombre: ${predio.nombrecompletopropietario}`, x, y, { maxWidth: 150 });
    doc.line(x, y + 0.5, 185, y + 0.5);
    y += 5;
    doc.text(`Ubicación: ${predio.ubicacion}`, x, y, { maxWidth: 150 });
    doc.line(x, y + 0.5, 185, y + 0.5);
    y += 5;
    doc.text(`Valor terreno: ${currencyFormater(predio.valor_del_terreno)}`, x, y, { maxWidth: 70 });
    doc.text(`Valor construcción: ${currencyFormater(predio.valor_de_la_construccion)}`, x + 70, y, { maxWidth: 70 });
    doc.line(x, y + 0.5, 185, y + 0.5);
    y += 5;
    doc.text(`Valor fiscal: ${currencyFormater(predio.valor_de_fiscal)}`, x, y, { maxWidth: 150 });
    doc.line(x, y + 0.5, 185, y + 0.5);
    y += 5;
    doc.text(`Dom. a notificar: ${predio.domicilio_notificacion}`, x, y, { maxWidth: 150 });
    doc.line(x, y + 0.5, 185, y + 0.5);
    y += 5;
    doc.text(`CURT: ${predio.curt}`, x, y, { maxWidth: 90 });
    doc.text(`Cuenta: ${predio.cuentadepredial}`, x + 90, y, { maxWidth: 60 });
    doc.line(x, y + 0.5, 185, y + 0.5);
    y += 5;
    doc.text(`Superficie terreno: ${predio.superficie_terreno}`, x, y, { maxWidth: 70 });
    doc.text(`Superficie construida: ${predio.superficie_construida}`, x + 70, y, { maxWidth: 70 });
    doc.line(x, y + 0.5, 185, y + 0.5);
    y += 5;
    doc.text(`Estatus del predio: ${predio.estatus_del_predio}`, x, y, { maxWidth: 70 });
    doc.line(x, y + 0.5, 185, y + 0.5);

    y += 10;
    doc.setFontSize(8);
    doc.text('EL PRESENTE ESTADO DE CUENTA ES VÁLIDO ÚNICAMENTE EL DÍA DE SU EXPEDICIÓN, Y ES EXCLUSIVAMENTE DE CARÁCTER INFORMATIVO; POR LO QUE NO SURTE EFECTOS JURÍDICOS A LOS CONTRIBUYENTES POR NO TRATARSE DE UNA RESOLUCIÓN ADMINISTRATIVA Y/O REQUERIMIENTO DE PAGO, DE CONFORMIDAD CON EL CÓDIGO FISCAL DE LA FEDERACIÓN Y EL ARTÍCULO 100 DEL CÓDIGO FISCAL DEL ESTADO DE JALISCO, VIGENTES.', 30, y, { align: 'justify', maxWidth: 150 });
    y += 18;

    text = 'ESTE DOCUMENTO NO ES VÁLIDO COMO COMPROBANTE DE PAGO, NI EXIME AL CONTRIBUYENTE DE '
    + 'ADEUDOS POSTERIORES A LA IMPRESIÓN DEL MISMO.';
    doc.text(text, 30, y, { align: 'justify', maxWidth: 150 });
    y += 9;

    text = `PARA PAGO EN SUCURSALES BANCARIAS, KIOSCOS, RECAUDADORAS, TIENDAS DE CONVENIENCIA
      VIGENTE SOLO PARA EL DÍA DE HOY ${currentDate}. UN DÍA DE RETRASO EN SU PAGO PODRÍA GENERAR
      OTROS CARGOS A LA FECHA DE IMPRESIÓN.`;
    doc.text(text, 30, y, { align: 'justify', maxWidth: 150 });
    doc.setFontStyle('normal');
    text = 'DESCUENTO ESPECIAL (DESP.): Descuento especial por concepto de tercera edad, pensionado, '
      + `jubilado y otros, se calcula de manera automática a quienes renovaron su descuento en ${prevYear}.\n`
      + 'DESCUENTO POR PRONTO PAGO(PAG.): Descuento que se otorga a todos los contribuyentes en el'
      + ` impuesto predial ${currentYear} respectivo al 10% y vigente al ${expDateStr}. El Impuesto `
      + `Predial correspondiente al ejercicio fiscal ${currentYear}, se calcula de acuerdo a lo que resulte de`
      + ' aplicar bimestralmente a la base fiscal, las cuotas y tasas establecidas por el articulo 45, '
      + 'fracción I, de la Ley de Ingresos del Municipio de Zapopan, Jalisco, para el Ejercicio Fiscal'
      + ` del año ${currentYear}.`;
    y += 12;
    x = 30;
    doc.text(text, 30, y, { maxWidth: 150, align: 'justify' });

    /*    doc.setFillColor(146, 104, 203);
    doc.setDrawColor(146, 104, 203); */
    doc.setTextColor(255, 255, 255);
    doc.setFontStyle('bold');
    y -= 47.5;
    // doc.roundedRect(x, y, 150, 4, 2, 2, 'FD');
    doc.setFontSize(6);

    y += 2.7;
    /*    doc.text(
      'Información Proactiva Impuesto Predial: www.zapopan.gob.mx/info-predial',
      35,
      y,
      { align: 'left', maxWidth: 100 },
    );
    x = 175;
    doc.text(
      'Correo: informacionpredial@zapopan.gob.mx',
      x,
      y,
      {
        align: 'right',
        maxWidth: 50,
      },
    ); */
    doc.setFontSize(10);
    // doc.setFillColor(202, 177, 229);
    // doc.setDrawColor(202, 177, 229);

    x = 30;
    y += 75.5;

    doc.setDrawColor(0, 0, 0);
    doc.roundedRect(25, y, 165, 79, 4, 4, 'S');

    doc.setFillColor(27, 1, 116);
    doc.setDrawColor(27, 1, 116);
    doc.roundedRect(25, y + 4, 165, 4, 0, 0, 'FD');
    doc.roundedRect(25, y, 165, 8, 4, 4, 'FD');
    x = 55;
    y -= 10;
    doc.roundedRect(x, y, 100, 8, 4, 4, 'FD');
    x += 50;
    y += 5.5;
    doc.text('ADEUDO AL DÍA DE HOY', x, y, {
      align: 'center',
      maxWidth: 100,
    });
    doc.setFontSize(12);
    x = 40;
    y += 10;
    doc.text('CONCEPTO', x, y);
    x += 100;
    doc.text('IMPORTE', x, y);
    doc.setDrawColor(0, 0, 0);
    doc.setFillColor(0, 0, 0);
    doc.setTextColor(0, 0, 0);

    // Conceptos
    doc.setFontSize(9);
    doc.setFontStyle('bold');
    x = 40;
    y += 6;
    doc.text(
      `El adeudo cubre del periodo ${firstPeriod.year} . ${firstPeriod.num} al periodo ${lastPeriod.year}. ${lastPeriod.num}`,
      x,
      y,
      { maxWidth: 150 },
    );
    y += 2;
    const conceptos = [
      'Impuesto causado',
      'Actualización',
      'Recargo',
      'Gastos de notificación',
      'Multas',
      'Descuento por pronto pago 10% y/o 3ra edad',
      'Descuento multas y recargos',
      'Redondeo',
      'IMPORTE A PAGAR',
      'Aportación OPD Servicios de Salud del Municipio de Zapopan',
    ];
    if (houseInsurance) {
      conceptos.push('Seguro exclusivo casa habitación');
    }
    conceptos.push('TOTAL A PAGAR');
    conceptos.forEach((concepto) => {
      y += 5;
      doc.text(concepto, x, y, { maxWidth: 120 });
      doc.line(x, y + 0.5, 170, y + 0.5);
    });

    // Importes
    const importes = [
      debtsTotalBase,
      actTotal,
      surchargeTotal,
      notificationTotal,
      finesTotal,
      discountEarlyPay,
      specialDiscountTotal,
      debtsTotalExtra,
      debtsTotalRounded,
      healthServicesTotal,
    ];
    if (houseInsurance) {
      importes.push(houseInsuranceTotal);
    }
    importes.push(total);
    y = 162.2;
    x = 160;
    doc.setFontStyle('normal');
    importes.forEach((importe) => {
      y += 5;
      doc.text(currencyFormater(importe), x, y, {
        maxWidth: 25,
        align: 'right',
      });
    });
    x = 25;
    y += 14;

    // Divider
    /*    doc.setFillColor(199, 174, 211);
    doc.setDrawColor(199, 174, 211);
    doc.rect(x, y, 140, 1, 'F');
    x -= 5;
    y += 5; */
    doc.addImage(imgFooterImage, 'JPEG', x, y, 165, 30, '', 'FAST');
    doc.addPage();

    const ref = predio.cuentadepredial.length === 10
      ? predio.cuentadepredial : predio.pk.toString().padStart(10, '0');
    const qrs = [];
    const barcodes = [];
    const codes = [];
    const uris = [];
    const amounts = [
      total,
      total - healthServicesTotal,
      total - houseInsuranceTotal,
      total - healthServicesTotal - houseInsuranceTotal,
    ];
    for (let idx = 0; idx < 4; idx++) {
      // Creando referencia
      const { LINEA_BANCOS, LINEA_OXXO } = generate(
        currentDate,
        amounts[idx],
        ref,
      );

      if (LINEA_OXXO) {
        // Creando codigo de barras
        const xmlSerializer = new XMLSerializer();
        const docum = document.implementation.createDocument(
          'http://www.w3.org/1999/xhtml',
          'html',
          null,
        );
        const svgNode = docum.createElementNS(
          'http://www.w3.org/2000/svg',
          'svg',
        );

        JsBarcode(svgNode, LINEA_OXXO, {
          xmlDocument: docum,
          height: 50,
        });
        const svgText = xmlSerializer.serializeToString(svgNode);
        let svg = svgText;
        svg = svg.replace(/\r?\n|\r/g, '').trim();
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        // eslint-disable-next-line no-await-in-loop
        const v = await Canvg.from(ctx, svg);
        v.start();
        // eslint-disable-next-line no-await-in-loop
        const imgData = await canvas.toDataURL('image/png');
        barcodes.push(imgData);
      } else {
        barcodes.push(false);
      }

      // Creando QR
      if (LINEA_BANCOS) {
        const qr = qrcode(0, 'L');
        const baseURL = 'http://pagos.zapopan.gob.mx/PortalCiudadano/Recaudacion/RecaudoPredialQR.aspx?';
        // const baseURL = 'https://pruebasigob.zapopan.gob.mx/PortalCiudadanoPagoPruebas/Recaudacion/RecaudoPredialQR.aspx?';
        const URI = `${baseURL}OidPredio=${predio.pk}&Importe=${amounts[idx].toFixed(2)}&FechaPago=${dateForLink}`;
        uris.push(URI);
        qr.addData(URI);
        qr.make();
        const data = qr.createDataURL();
        qrs.push(data);
        codes.push(LINEA_BANCOS);
      } else {
        qrs.push(false);
        codes.push(false);
      }
    }

    const blank = '    ';
    doc.setFontSize(12);
    doc.setFontStyle('bold');
    x = 105;
    y = 15;

    doc.setDrawColor(27, 1, 116);
    doc.setFillColor(27, 1, 116);
    doc.roundedRect(50, y - 5, 110, 8, 4, 4, 'FD');
    doc.setTextColor(255, 255, 255);
    doc.text('Escanea o da clic en el código QR de tu preferencia', x, y, { align: 'center' });
    doc.setTextColor(0, 0, 0);

    if (houseInsurance) {
      x = 10 + (190 / 4);
      y += 8;
      doc.text('Con seguro con donativo', x, y, { maxWidth: 75, align: 'center' });
      x = 10 + (190 / 4) * 3;
      doc.text('Con seguro sin donativo', x, y, { maxWidth: 75, align: 'center' });
      doc.setFontStyle('normal');
      doc.setFontSize(10);

      const marginBottomTitle = 5;
      const marginBottomQr = 30;
      const marginBottomBarCode = 20;
      const marginBottomAdeudo = 10;
      // const marginBottomCode = 10;
      // Validación QR
      const exceedMsg = 'Las cantidades a pagar exceden los límites establecidos';
      if (qrs[0]) {
        x = 10 + (190 / 4) - 11;
        y += marginBottomTitle;
        doc.addImage(qrs[0], 'JPEG', x, y, 22, 27.3, '', 'FAST');
        doc.setFontSize(55);
        doc.textWithLink(blank, x, y + 20, { url: uris[0] });
        doc.setFontSize(10);
        y += marginBottomQr;
      } else {
        doc.setFontStyle('bold');
        x = 10 + (190 / 4);
        y += marginBottomTitle + 15;
        doc.text(
          exceedMsg,
          x,
          y,
          { maxWidth: 70, align: 'center' },
        );
        doc.setFontStyle('normal');
        y += marginBottomQr - 10;
      }

      // Validación código de barras
      x = 10 + (190 / 4);
      if (barcodes[0]) {
        doc.addImage(barcodes[0], 'JPEG', x - 35, y, 70, 15);
      } else {
        doc.setFontStyle('bold');
        doc.text(
          exceedMsg,
          x,
          y,
          { maxWidth: 60, align: 'center' },
        );
        doc.setFontStyle('normal');
      }
      y += marginBottomBarCode;
      doc.setFontSize(6);
      doc.text(`ADEUDO A LA FECHA  ${dateForLink}`, x - 15, y, { maxWidth: 25, align: 'center' });
      doc.setFontSize(8);
      doc.text(`${currencyFormater(amounts[0])}`, x + 15, y + 2.5, {
        maxWidth: 30,
        align: 'center',
      });
      if (codes[0]) {
        y += marginBottomAdeudo;
        doc.text(`${codes[0]}`, x, y, { maxWidth: 75, align: 'center' });
      }
      doc.setFontSize(8);
      doc.setFontStyle('bold');
      doc.text('ESTE MONTO SOLO VALIDO EN ESTA FECHA', x - 39, y + 5, { maxWidth: 175, align: 'left' });
      cx = 10 + (190 / 4);
      y += 5;
      doc.setFontStyle('bold');
      doc.text('PAGO VIA SPEI DESDE CUALQUIER BANCO:', cx, y + 5, { align: 'center' });
      doc.setFontSize(8);
      doc.setTextColor(0, 0, 0);
      doc.text('REFERENCIA (CONCEPTO):', cx - 16, y + 10, { align: 'center' });
      doc.text('CLABE INTERBANCARIA:', cx - 17, y + 15, { align: 'center' });
      doc.text(codes[0], cx + 3, y + 10);
      doc.text('012914002004511392', cx + 2, y + 15);
      doc.setFontStyle('normal');
      y += 15; doc.setFontSize(10);
      // Dibujando dividers
      doc.setDrawColor(161, 120, 252);
      doc.setLineWidth(0.3);
      doc.line(105, 33, 105, 80);

      y = 23;
      if (qrs[1]) {
        x = 10 + (190 / 4) * 3 - 11;
        y += marginBottomTitle;
        doc.addImage(qrs[1], 'JPEG', x, y, 22, 27.3, '', 'FAST');
        doc.setFontSize(55);
        doc.textWithLink(blank, x, y + 20, { url: uris[1] });
        doc.setFontSize(10);
        y += marginBottomQr;
      } else {
        doc.setFontStyle('bold');
        x = 10 + (190 / 4) * 3;
        y += 20;
        doc.text(
          exceedMsg,
          x,
          y,
          { maxWidth: 70, align: 'center' },
        );
        doc.setFontStyle('normal');
        y += marginBottomQr - 10;
      }

      // Validación código de barras
      x = 10 + (190 / 4) * 3;
      if (barcodes[1]) {
        doc.addImage(barcodes[1], 'JPEG', x - 35, y, 70, 15);
      } else {
        doc.setFontStyle('bold');
        doc.text(
          exceedMsg,
          x,
          y,
          { maxWidth: 60, align: 'center' },
        );
        doc.setFontStyle('normal');
      }
      y += marginBottomBarCode;
      doc.setFontSize(6);
      doc.text(`ADEUDO A LA FECHA  ${dateForLink}`, x - 15, y - 4, { maxWidth: 25, align: 'center' });
      doc.setFontSize(8);
      doc.text(`${currencyFormater(amounts[1])}`, x + 15, y + 2.5, {
        maxWidth: 30,
        align: 'center',
      });
      if (codes[1]) {
        y += marginBottomAdeudo;
        doc.text(`${codes[1]}`, x, y, { maxWidth: 75, align: 'center' });
      }
      doc.setFontSize(8);
      doc.setFontStyle('bold');
      doc.text('ESTE MONTO SOLO VALIDO EN ESTA FECHA', x - 39, y + 5, { maxWidth: 175, align: 'left' });
      cx = 10 + (190 / 4) * 3;
      y += 5;
      doc.setFontStyle('bold');
      doc.text('PAGO VIA SPEI DESDE CUALQUIER BANCO:', cx, y + 5, { align: 'center' });
      doc.setFontSize(8);
      doc.setTextColor(0, 0, 0);
      doc.text('REFERENCIA (CONCEPTO):', cx - 16, y + 10, { align: 'center' });
      doc.text('CLABE INTERBANCARIA:', cx - 17, y + 15, { align: 'center' });
      doc.text(codes[1], cx + 3, y + 10);
      doc.text('012914002004511392', cx + 2, y + 15);
      doc.setFontStyle('normal');
      y += 15; doc.setFontSize(10);

      y += 10;
      const backToTop = y;
      doc.setFontSize(12);
      doc.setFontStyle('bold');
      x = 10 + (190 / 4);
      doc.text('Sin seguro con donativo', x, y, { maxWidth: 75, align: 'center' });
      x = 10 + (190 / 4) * 3;
      doc.text('Sin seguro sin donativo', x, y, { maxWidth: 75, align: 'center' });
      doc.setFontStyle('normal');
      doc.setFontSize(10);
      if (qrs[2]) {
        x = 10 + (190 / 4) - 11;
        y += marginBottomTitle;
        doc.addImage(qrs[2], 'JPEG', x, y, 22, 27.3, '', 'FAST');
        doc.setFontSize(55);
        doc.textWithLink(blank, x, y + 20, { url: uris[2] });
        doc.setFontSize(10);
        y += marginBottomQr;
      } else {
        doc.setFontStyle('bold');
        x = 10 + (190 / 4);
        y += 20;
        doc.text(
          exceedMsg,
          x,
          y,
          { maxWidth: 70, align: 'center' },
        );
        doc.setFontStyle('normal');
        y += marginBottomQr - 10;
      }

      // Validación código de barras
      x = 10 + (190 / 4);
      if (barcodes[2]) {
        doc.addImage(barcodes[2], 'JPEG', x - 35, y, 70, 15);
      } else {
        doc.setFontStyle('bold');
        doc.text(
          exceedMsg,
          x,
          y,
          { maxWidth: 60, align: 'center' },
        );
        doc.setFontStyle('normal');
      }
      y += marginBottomBarCode;
      doc.setFontSize(6);
      doc.text(`ADEUDO A LA FECHA  ${dateForLink}`, x - 15, y, { maxWidth: 25, align: 'center' });
      doc.setFontSize(8);
      doc.text(`${currencyFormater(amounts[2])}`, x + 15, y + 2.5, {
        maxWidth: 30,
        align: 'center',
      });
      if (codes[2]) {
        y += marginBottomAdeudo;
        doc.text(`${codes[2]}`, x, y, { maxWidth: 75, align: 'center' });
      }
      doc.setFontSize(8);
      doc.setFontStyle('bold');
      doc.text('ESTE MONTO SOLO VALIDO EN ESTA FECHA', x - 39, y + 5, { maxWidth: 175, align: 'left' });
      cx = 10 + (190 / 4);
      y += 5;
      doc.setFontStyle('bold');
      doc.text('PAGO VIA SPEI DESDE CUALQUIER BANCO:', cx, y + 5, { align: 'center' });
      doc.setFontSize(8);
      doc.setTextColor(0, 0, 0);
      doc.text('REFERENCIA (CONCEPTO):', cx - 16, y + 10, { align: 'center' });
      doc.text('CLABE INTERBANCARIA:', cx - 17, y + 15, { align: 'center' });
      doc.text(codes[2], cx + 3, y + 10);
      doc.text('012914002004511392', cx + 2, y + 15);
      doc.setFontStyle('normal');
      doc.setFontSize(10);
      y = backToTop;
      doc.line(105, y + 10, 105, y + 57);

      if (qrs[3]) {
        x = 10 + (190 / 4) * 3 - 11;
        y += marginBottomTitle;
        doc.addImage(qrs[3], 'JPEG', x, y, 22, 27.3, '', 'FAST');
        doc.setFontSize(55);
        doc.textWithLink(blank, x, y + 20, { url: uris[3] });
        doc.setFontSize(10);
        y += marginBottomQr;
      } else {
        doc.setFontStyle('bold');
        x = 10 + (190 / 4) * 3;
        y += 20;
        doc.text(
          exceedMsg,
          x,
          y,
          { maxWidth: 70, align: 'center' },
        );
        doc.setFontStyle('normal');
        y += marginBottomQr - 10;
      }

      // Validación código de barras
      x = 10 + (190 / 4) * 3;
      if (barcodes[3]) {
        doc.addImage(barcodes[3], 'JPEG', x - 35, y, 70, 15);
      } else {
        doc.setFontStyle('bold');
        doc.text(
          exceedMsg,
          x,
          y,
          { maxWidth: 60, align: 'center' },
        );
        doc.setFontStyle('normal');
      }
      y += marginBottomBarCode;
      doc.setFontSize(6);
      doc.text(`ADEUDO A LA FECHA  ${dateForLink}`, x - 15, y, { maxWidth: 25, align: 'center' });
      doc.setFontSize(8);
      doc.text(`${currencyFormater(amounts[3])}`, x + 15, y + 2.5, {
        maxWidth: 30,
        align: 'center',
      });
      if (codes[3]) {
        y += marginBottomAdeudo;
        doc.text(`${codes[3]}`, x, y, { maxWidth: 75, align: 'center' });
      }
      doc.setFontSize(8);
      doc.setFontStyle('bold');
      doc.text('ESTE MONTO SOLO VALIDO EN ESTA FECHA', x - 39, y + 5, { maxWidth: 175, align: 'left' });
      cx = 10 + (190 / 4) * 3;
      y += 5;
      doc.setFontStyle('bold');
      doc.text('PAGO VIA SPEI DESDE CUALQUIER BANCO:', cx, y + 5, { align: 'center' });
      doc.setFontSize(8);
      doc.setTextColor(0, 0, 0);
      doc.text('REFERENCIA (CONCEPTO):', cx - 16, y + 10, { align: 'center' });
      doc.text('CLABE INTERBANCARIA:', cx - 17, y + 15, { align: 'center' });
      doc.text(codes[3], cx + 3, y + 10);
      doc.text('012914002004511392', cx + 2, y + 15);
      doc.setFontStyle('normal');
      y += 15; doc.setFontSize(10);
    } else {
      x = 10 + (190 / 4);
      y += 8;
      doc.text('Con donativo', x, y, { maxWidth: 75, align: 'center' });
      x = 10 + (190 / 4) * 3;
      doc.text('Sin donativo', x, y, { maxWidth: 75, align: 'center' });
      doc.setFontStyle('normal');
      doc.setFontSize(10);

      const marginBottomTitle = 5;
      const marginBottomQr = 30;
      const marginBottomBarCode = 20;
      const marginBottomAdeudo = 10;
      // const marginBottomCode = 10;
      // Validación QR
      const exceedMsg = 'Las cantidades a pagar exceden los límites establecidos';
      if (qrs[2]) {
        x = 10 + (190 / 4) - 11;
        y += marginBottomTitle;
        doc.addImage(qrs[2], 'JPEG', x, y, 22, 27.3, '', 'FAST');
        doc.setFontSize(55);
        doc.textWithLink(blank, x, y + 20, { url: uris[2] });
        doc.setFontSize(10);
        y += marginBottomQr;
      } else {
        doc.setFontStyle('bold');
        x = 10 + (190 / 4);
        y += marginBottomTitle + 15;
        doc.text(
          exceedMsg,
          x,
          y,
          { maxWidth: 70, align: 'center' },
        );
        doc.setFontStyle('normal');
        y += marginBottomQr - 10;
      }

      // Validación código de barras
      x = 10 + (190 / 4);
      if (barcodes[2]) {
        doc.addImage(barcodes[2], 'JPEG', x - 35, y, 70, 15);
      } else {
        doc.setFontStyle('bold');
        doc.text(
          exceedMsg,
          x,
          y,
          { maxWidth: 60, align: 'center' },
        );
        doc.setFontStyle('normal');
      }
      y += marginBottomBarCode;

      doc.setFontSize(6);
      doc.text(`ADEUDO A LA FECHA  ${dateForLink}`, x - 15, y - 4, { maxWidth: 25, align: 'center' });
      doc.setFontSize(8);
      doc.text(`${currencyFormater(amounts[2])}`, x + 15, y + 2.5, {
        maxWidth: 30,
        align: 'center',
      });
      if (codes[2]) {
        y += marginBottomAdeudo;
        doc.text(`${codes[2]}`, x, y, { maxWidth: 75, align: 'center' });
      }
      doc.setFontSize(8);
      doc.setFontStyle('bold');
      doc.text('ESTE MONTO SOLO VALIDO EN ESTA FECHA', x - 39, y + 5, { maxWidth: 175, align: 'left' });
      doc.setFontStyle('normal');
      cx = 10 + (190 / 4);
      y += 5;
      doc.setFontSize(10);
      doc.setFontStyle('bold');
      doc.text('PAGO VIA SPEI DESDE CUALQUIER BANCO:', cx, y + 5, { align: 'center' });
      doc.setFontSize(8);
      doc.setTextColor(0, 0, 0);
      doc.text('REFERENCIA (CONCEPTO):', cx - 16, y + 10, { align: 'center' });
      doc.text('CLABE INTERBANCARIA:', cx - 17, y + 15, { align: 'center' });
      doc.text(codes[2], cx + 3, y + 10);
      doc.text('012914002004511392', cx + 2, y + 15);
      doc.setFontStyle('normal');
      doc.setFontSize(10);
      // Dibujando dividers
      doc.setDrawColor(161, 120, 252);
      doc.setLineWidth(0.3);
      doc.line(105, 33, 105, 80);

      y = 23;
      if (qrs[3]) {
        x = 10 + (190 / 4) * 3 - 11;
        y += marginBottomTitle;
        doc.addImage(qrs[3], 'JPEG', x, y, 22, 27.3, '', 'FAST');
        doc.setFontSize(55);
        doc.textWithLink(blank, x, y + 20, { url: uris[3] });
        doc.setFontSize(10);
        y += marginBottomQr;
      } else {
        doc.setFontStyle('bold');
        x = 10 + (190 / 4) * 3;
        y += 20;
        doc.text(
          exceedMsg,
          x,
          y,
          { maxWidth: 70, align: 'center' },
        );
        doc.setFontStyle('normal');
        y += marginBottomQr - 10;
      }

      // Validación código de barras
      x = 10 + (190 / 4) * 3;
      if (barcodes[3]) {
        doc.addImage(barcodes[3], 'JPEG', x - 35, y, 70, 15);
      } else {
        doc.setFontStyle('bold');
        doc.text(
          exceedMsg,
          x,
          y,
          { maxWidth: 60, align: 'center' },
        );
        doc.setFontStyle('normal');
      }
      y += marginBottomBarCode;
      doc.setFontSize(6);
      doc.text(`ADEUDO A LA FECHA  ${dateForLink}`, x - 15, y - 4, { maxWidth: 25, align: 'center' });
      doc.setFontSize(8);
      doc.text(`${currencyFormater(amounts[3])}`, x + 15, y + 2.5, {
        maxWidth: 30,
        align: 'center',
      });
      if (codes[3]) {
        y += marginBottomAdeudo;
        doc.text(`${codes[3]}`, x, y, { maxWidth: 75, align: 'center' });
      }
      doc.setFontSize(8);
      doc.setFontStyle('bold');
      doc.text('ESTE MONTO SOLO VALIDO EN ESTA FECHA', x - 39, y + 5, { maxWidth: 175, align: 'left' });
      doc.setFontSize(10);
      cx = 10 + (190 / 4) * 3;
      y += 5;
      doc.setFontStyle('bold');
      doc.text('PAGO VIA SPEI DESDE CUALQUIER BANCO:', cx, y + 5, { align: 'center' });
      doc.setFontSize(8);
      doc.setTextColor(0, 0, 0);
      doc.text('REFERENCIA (CONCEPTO):', cx - 16, y + 10, { align: 'center' });
      doc.text('CLABE INTERBANCARIA:', cx - 17, y + 15, { align: 'center' });
      doc.text(codes[3], cx + 3, y + 10);
      doc.text('012914002004511392', cx + 2, y + 15);
      doc.setFontStyle('normal');
      y += 15; doc.setFontSize(10);
    }
    y += 10;

    doc.setFontSize(8);
    doc.text('BBVA: 451139 | Santander: 618 | Scotiabank: 1519 | HSBC: 1415 | Banorte: 8247 | Banamex: 4905 | Banco del Bajio: 668', 30, y, {});

    /* doc.text('BBVA Bancomer: 451139', 48.5, y, {
      maxWidth: 37.5,
      align: 'center',
    });
    doc.text('Santander: 618', 86.5, y, { maxWidth: 37.5, align: 'center' });
    doc.text('Scotiabank: 1519', 124, y, { maxWidth: 37.5, align: 'center' });
    doc.text('HSBC: 1415', 161.5, y, { maxWidth: 37.5, align: 'center' });
    y += 10;
    doc.text('Banorte: 8247', 55, y, { maxWidth: 50, align: 'center' });
    doc.text('Banamex: 1104', 105, y, { maxWidth: 50, align: 'center' });
    doc.text('Banco del Bajio: 668', 155, y, {
      maxWidth: 50,
      align: 'center',
    }); */
    // y += 8;
    // doc.addImage(imgAcudeBancos, 'JPEG', 30, y, 120, 10, '', 'FAST');
    y += 5;
    doc.addImage(imgBannerFondo, 'JPEG', 20, y, 165, 40, '', 'FAST');
    /* console.log('codes ');
    console.log(codes);
    console.log('predio en recibo ');
    console.log(predio);
    console.log('cargos en recibo '+predio.cargos); */
    /*
      const resGuardarRef = await axios.post(
      "https://indicadores.zapopan.gob.mx:8080/WSCajaWeb/api/guardaReferenciaWeb",
      {
        padron_id: predio.pk.toString(),
        total: total,
        redondeo: debtsTotalExtra,
        idConsulta: predio.idConsulta,
        anio: currentYear,
        bim: 6,
        canalDePago: 0,
        referencia: codes[0],
        referenciaopd: codes[1],
        referenciaseguro: codes[2],
        referenciaopdseguro: codes[3],
        cargos: predio.cargos,
      }

    );
    */
    return doc;
  } catch (err) {
    console.error(err);
    return err;
  }
}
